import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import RedirectPage from './redirect';
import { Base, BaseType as BaseType_ } from '../common/base-component';
import { AppState as AppState_ } from '../../redux/app-state';

type LogoutCallbackProps = {
} & BaseType_

export class LogoutCallback extends Base<LogoutCallbackProps, {}> {
  constructor(props) {
    super(props);

    const {
      history,
    } = this.props;

    const { match: { params: { autologout, }, }, } = this.props;

    localStorage.clear();
    history.push(autologout ? '/?autologout=1' : '/');
  }

  content =() => <RedirectPage />
}

export default withRouter(connect(
  (state: AppState_) => ({ ...state, })
)(LogoutCallback));
